export default function PHP_addcslashes() {
  return (
    <div>
      <h1>PHP_addcslashes</h1>
    </div>
  );
}
